import classNames from 'classnames';
import React from 'react';

export interface LinearProgressProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  /**
   * 不確定かどうか.
   */
  isIndeterminate?: boolean;
  /**
   * 進捗率(%). 0~100 の数値
   */
  value?: number;
  /**
   * 背景を持つかどうか
   */
  hasBackground?: boolean
}

const LinearProgress: React.FC<LinearProgressProps> = ({
  isIndeterminate = false,
  value = 35,
  className,
  hasBackground = true,
  ...props
}) => {
  const classes = classNames(
    "uc-progress",
    className,
    isIndeterminate && "uc-progress--indeterminate"
  )

  return (
    <div className={classes} {...props}>
      <svg className="uc-progress__bar" xmlns="http://www.w3.org/2000/svg" height="4" style={{ width: "100%" }}>
        {hasBackground && 
          <rect
            className="uc-progress__bar-background"
            x="0"
            y="0"
            rx="2"
            ry="2" 
            style={{
              width: "100%",
              height: 4 + "px",
            }}
            />}
        <rect
          className="uc-progress__bar-indicator"
          x="0"
          y="0"
          rx="2"
          ry="2" 
          style={{
            width: value + "%",
            height: 4 + "px",
          }}
        />
      </svg>
    </div>
  );
};

export default LinearProgress;